module.exports = __webpack_public_path__ + "img/flux_couvert.2360b381.jpg";